// extracted by mini-css-extract-plugin
export default {"face":"Face-module__[local]___tETC6"};